import api from '@/lib/api';
import type { GeocodeAutocompleteResponse } from '@pms/shared';

/**
 * GET /v1/public/geocode/autocomplete — as-you-type place suggestions (TASK-146).
 * The staff axios client is scoped to `/v1` (not `/v1/public`), so we call the
 * absolute public path. The route is @Public — the staff token is ignored.
 */
export async function geocodeAutocomplete(
  q: string,
  limit = 6,
  signal?: AbortSignal,
): Promise<GeocodeAutocompleteResponse> {
  const { data } = await api.get<GeocodeAutocompleteResponse>(
    '/public/geocode/autocomplete',
    { params: { q, limit }, ...(signal ? { signal } : {}) },
  );
  return data;
}
